'use client';

import React from 'react';
import clsx from 'clsx';
import styles from './TextFieldLabel.module.css';

export function TextFieldLabel({
  className,
  ...props
}: React.LabelHTMLAttributes<HTMLLabelElement>) {
  return <label className={clsx(styles.label, className)} {...props} />;
}
